import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MCPIcon = ({})=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                "clip-path": "url(#clip0_792_2516)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.6763 3.01819C11.9491 2.30546 10.7854 2.30546 10.0582 3.01819L3.0618 9.88364C2.81453 10.1164 2.43635 10.1164 2.18907 9.88364C1.95635 9.65091 1.9418 9.27273 2.18907 9.04L9.18544 2.16C10.4073 0.981822 12.3418 0.981822 13.5636 2.16C14.2473 2.82909 14.5818 3.78909 14.4363 4.73455C15.3963 4.60364 16.3709 4.90909 17.0545 5.59273L17.0836 5.63637C18.2618 6.78546 18.2909 8.67637 17.1418 9.86909C17.1273 9.88364 17.0982 9.91273 17.0836 9.92728L10.7563 16.1382C10.6836 16.2109 10.6691 16.3418 10.7563 16.4145L12.0509 17.6945C12.2836 17.9273 12.2982 18.3055 12.0509 18.5382C11.8036 18.7709 11.4254 18.7709 11.1782 18.5382L9.88362 17.2582C9.33089 16.72 9.31635 15.8327 9.85453 15.28C9.85453 15.28 9.86907 15.2655 9.88362 15.2509L16.2109 9.04C16.9236 8.34182 16.9382 7.20728 16.24 6.49455L16.2109 6.46546L16.1818 6.43637C15.4545 5.72364 14.2909 5.72364 13.5636 6.43637L8.3418 11.5564L8.26907 11.6291C8.0218 11.8618 7.64362 11.8618 7.39635 11.6291C7.16362 11.3964 7.14908 11.0182 7.39635 10.7855L12.6909 5.59273C13.4036 4.89455 13.4182 3.76 12.72 3.04728C12.72 3.04728 12.7054 3.03273 12.6909 3.01819H12.6763Z",
                        fill: "#676879"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.8036 4.73449C12.0363 4.50176 12.0509 4.12358 11.8036 3.89085C11.5563 3.65813 11.1782 3.65813 10.9309 3.89085L5.75271 8.96722C4.57453 10.1163 4.54544 12.0072 5.69453 13.1999C5.70907 13.2145 5.73817 13.2436 5.75271 13.2581C6.97453 14.4363 8.90907 14.4363 10.1309 13.2581L15.3091 8.18176C15.5418 7.94904 15.5563 7.57085 15.3091 7.33813C15.0618 7.1054 14.6836 7.1054 14.4363 7.33813L9.25817 12.4145C8.53089 13.1272 7.36726 13.1272 6.63998 12.4145C5.92726 11.7163 5.91271 10.5818 6.61089 9.86904L6.63998 9.83994L11.8182 4.76358L11.8036 4.73449Z",
                        fill: "#676879"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_792_2516",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "16",
                        height: "17.4545",
                        fill: "white",
                        transform: "translate(2 1.27271)"
                    })
                })
            })
        ]
    });
